module.exports = __webpack_public_path__ + "static/media/InitialSymbol_jpg.6ec9821f.jpg";